"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nInit = void 0;
var i18next_1 = __importDefault(require("i18next"));
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var react_i18next_1 = require("react-i18next");
var asset_variant_1 = __importDefault(require("../../shared/util/asset-variant"));
var pathVariant = "/locales/" + asset_variant_1.default + "/{{lng}}/{{ns}}.json";
exports.i18nInit = i18next_1.default
    // load translation using http -> see /public/locales
    .use(i18next_http_backend_1.default)
    .use(react_i18next_1.initReactI18next) // Passes i18n down to react-i18next.
    .init({
    // debug: true, // For verbose logging in development.
    backend: {
        loadPath: pathVariant,
    },
    lng: 'en',
    fallbackLng: 'en',
    whitelist: ['en'],
    interpolation: {
        escapeValue: false, // React already safes from xss.
    },
    initImmediate: false,
});
exports.default = i18next_1.default;
